module.exports = __webpack_public_path__ + "/images/ico-vendedores-estilo.043476f.svg";